import { Routes } from "@angular/router";
import { ArAgingDetailsReportComponent } from "./components/ar-aging-details-report/ar-aging-details-report.component";
import { CustomerAgingDetailReportComponent } from "./components/customer-aging-detail-report/customer-aging-detail-report.component";
import { CustomerSettlementComponent } from "./components/customer-settlement/customer-settlement.component";
import { OpenClientCreditsComponent } from "./components/open-client-credits/open-client-credits.component";
import { OpenCustomerInvoicesReportComponent } from "./components/open-customer-invoices-report/open-customer-invoices-report.component";
import { OrderBilledInvoicedDetailsComponent } from "./components/order-billed-invoiced-details/order-billed-invoiced-details.component";
import { OrderWrittenReportPaginatedComponent } from "./components/order-written-report-paginated/order-written-report-paginated.component";
import { OrderWrittenReportComponent } from "./components/order-written-report/order-written-report.component";
import { ReadyToBillComponent } from "./components/ready-to-bill/ready-to-bill.component";
import { RptClientReportComponent } from "./components/rpt-tc-client-report/rpt-client-report/rpt-client-report.component";
import { YearOverYearReportComponent } from "./components/year-over-year-report/year-over-year-report.component";
import { ReportsComponent } from "./reports.component";

export const reportRoutes: Routes = [
  { path: "", component: ReportsComponent },
  { path: "order-written-report", component: OrderWrittenReportComponent },
  {
    path: "order-written-report-paginated",
    component: OrderWrittenReportPaginatedComponent,
  },
  {
    path: "order-written-report/admin",
    component: OrderWrittenReportPaginatedComponent,
  },
  {
    path: "order-billed-invoiced",
    component: OrderBilledInvoicedDetailsComponent,
  },
  {
    path: "customer-aging-detail-report",
    component: CustomerAgingDetailReportComponent,
  },
  {
    path: "customer-settlement/:id",
    component: CustomerSettlementComponent,
  },
  {
    path: "open-customer-invoices-report",
    component: OpenCustomerInvoicesReportComponent,
  },
  {
    path: "open-customer-invoices-report/:customerAccount",
    component: OpenCustomerInvoicesReportComponent,
  },
  {
    path: "ar-aging-detail-report",
    component: ArAgingDetailsReportComponent,
  },
  {
    path: "ar-aging-detail-report/:CustomerId/:selectionRadioType",
    component: ArAgingDetailsReportComponent,
  },
  {
    path: "ready-to-bill",
    component: ReadyToBillComponent,
  },
  {
    path: "rpt-top-client",
    component: RptClientReportComponent,
  },
  {
    path: "open-client-credits",
    component: OpenClientCreditsComponent,
  },
  {
    path: "year-over-year",
    component: YearOverYearReportComponent,
  },
];
